import { render } from "./FloorsList.vue?vue&type=template&id=6f6ff887&scoped=true"
import script from "./FloorsList.vue?vue&type=script&lang=js"
export * from "./FloorsList.vue?vue&type=script&lang=js"

import "./FloorsList.vue?vue&type=style&index=0&id=6f6ff887&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6ff887"]])

export default __exports__